<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="illu"><a id="page_ix"></a><strong>LIST OF ILLUSTRATIONS</strong></h2>
<p class="noindent1">Photographs not credited below have kindly been supplied by the author. While every effort has been made to trace the owners of copyright material reproduced herein, the publishers would like to apologise for any omissions and will be pleased to incorporate missing acknowledgments in any future editions.</p>
<p class="noindent1"><strong><span class="small">FIRST PLATE SECTION</span></strong></p>
<p class="noindent1"><strong><em>Pages 2 and 3:</em></strong></p>
<p class="noindent">Camp Bastion: Johnny Green/PA Archive/PA Photos.</p>
<p class="noindent">The Camp Bastion Apache flight line: Lt Col Felton.</p>
<p class="noindent">Apache Gunner’s Cockpit: AgustaWestland.</p>
<p class="noindent">Ed Macy: Lt Col Felton.</p>
<p class="noindent1"><strong><em>Pages 4 and 5:</em></strong></p>
<p class="noindent">Cockpit pilot’s view: SSgt Carl Bird.</p>
<p class="hanging">The cannon spitting out 10 rounds a second: Image by Corporal Mark Ballantyne RLC; © Crown Copyright/MOD. Reproduced with the permission of the Controller of Her Majesty’s Stationery office.</p>
<p class="hanging"><a id="page_x"></a>The Apache’s CRV-7 Flechette rockets: Image by Corporal Mark Ballantyne RLC; © Crown Copyright/MOD. Reproduced with the permission of the Controller of Her Majesty’s Stationery office.</p>
<p class="hanging">The Apache’s M230 30mm underslung chain gun: Image by Corporal Mark Ballantyne RLC; © Crown Copyright/MOD. Reproduced with the permission of the Controller of Her Majesty’s Stationery office.</p>
<p class="hanging">Ed and Trigger with Hambly reconnecting Ugly 51’s gun: Si Hambly.</p>
<p class="hanging">Hellfire at the back, rockets in the sangar and 30mm HEDP being loaded by Si: Si Hambly.</p>
<p class="hanging">The infamous Rocco: Rocco Seffredi.</p>
<p class="noindent1"><strong><em>Page 6 and 7:</em></strong></p>
<p class="hanging">A Taliban commander talks on a radio carrying an RPG launcher and spare rockets: AP Photo/Zaheerudding Abdullah.</p>
<p class="hanging">The IRT pair returning from a mission empty: Gerban Van Es.</p>
<p class="hanging">Arming Teams 3 and 4: Si Hambly.</p>
<p class="noindent1">SECOND PLATE SECTION</p>
<p class="noindent1"><strong><em>Page 1:</em></strong></p>
<p class="hanging">Ammo Sgt Kev Blundell paying his respects on Christmas Day: Sgt Kev Blundell.</p>
<p class="hanging">A message for the Taliban at Koshtay from arming point 2: Si Hambly.</p>
<p class="noindent1">Ed and Carl’s Hellfire page: SSgt Carl Bird.
</p>
<p class="noindent1"><strong><em>Pages 2 and 3:</em></strong></p>
<p class="noindent1">An Afghan National Policeman overlooking the Lashkar Gah Green Zone: AFP/Getty Images.</p>
<p class="noindent1"><a id="page_xi"></a>Rockets fired in quads: © Crown Copyright/MOD. Reproduced with the permission of the Controller of Her Majesty’s Stationery Office.</p>
<p class="noindent1">Hellfire fired by Ugly Five One and guided by Ugly Five Zero at Jugroom Fort: © Crown Copyright/MOD. Reproduced with the permission of the Controller of Her Majesty’s Stationery Office.</p>
<p class="noindent1"><strong><em>Pages 4 and 5:</em></strong></p>
<p class="hanging">Mountains that surround Now Zad and the Green Zone: LCpl Mathew Ford RM.</p>
<p class="hanging">The rescue team for Jugroom Fort: Sgt Garry Stanton, RAF.</p>
<p class="hanging">The rescue briefing in the desert: Sgt Garry Stanton, RAF.</p>
<p class="hanging">Lt Col Rob Magowan MBE RM – the loneliness of command: Sgt Garry Stanton, RAF.</p>
<p class="hanging">On the wings of the Apache ready to go: Sgt Garry Stanton, RAF.</p>
<p class="hanging">Ugly Five One with Capt Dave Rigg and Mne Chris Fraser-Perry riding to the Fort: Sgt Garry Stanton, RAF.</p>
<p class="hanging">Ugly Five Zero with RSM Hearn, filmed by Ugly Five One: © Crown Copyright/MOD. Reproduced with the permission of the Controller of Her Majesty’s Stationery Office.</p>
<p class="noindent1"><strong><em>Pages 6 and 7:</em></strong></p>
<p class="hanging">A true account of the rescue by the military artist David Rowlands, Ed Macy (with pistol) in front of Mathew Ford: David Rowlands.</p>
<p class="noindent1">The Jugroom Fort before and after January 15th: © Crown Copyright/MOD. Reproduced with the permission of the Controller of Her Majesty’s Stationery Office.</p>
<p class="noindent1">Taliban village next to Jugroom Fort before and after January 15th: © Crown Copyright/MOD. Reproduced with the permission of the Controller of Her Majesty’s Stationery Office.</p>
<p class="noindent1"><a id="page_xii"></a><strong><em>Page 8:</em></strong></p>
<p class="hanging">3 Flight – Charlotte, Darwin and Nick where the marines strapped onto the Apache during the Jugroom Fort rescue, and FOG: Si Hambly.</p>
<p class="hanging">Investiture ceremony at Buckingham Palace: Charles Green Photography.</p>
<p class="noindent1">Lance Corporal Mathew Ford, Royal Marines: LCpl Mathew Ford RM.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// illu.vue?403450fa